import { AppLayout } from "../shared";
import User from "../user/user";

const User_layout = ({ props, setIsLoaded }) => {
  return (
    <AppLayout props={props}>
      <User props={props} setIsLoaded={setIsLoaded} />
    </AppLayout>
  );
};

export default User_layout;